exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-select .dropdown-toggle[data-v-17f21124]{background:#fff;border-radius:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17f21124","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/assets/js/components/person/residents/new-resident-details/ResidentModifyLedgerPaymentSlideout.vue
// module id = j9vT
// module chunks = 0 1